import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { factory, Input, Text, useProps, useStyles } from "@coveord/plasma-mantine";
import { Locales } from "../../strings/Locales.js";
var renderValue = function(value) {
    if (value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0) {
        return /*#__PURE__*/ _jsx(Text, {
            c: "dimmed",
            children: Locales.format("ValueWithLabel.notApplicableLabel")
        });
    } else if (typeof value === "string") {
        return /*#__PURE__*/ _jsx(Text, {
            c: "gray.7",
            children: value
        });
    } else if (Array.isArray(value) && value.every(function(v) {
        return typeof v === "string";
    })) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: value.map(function(val) {
                return /*#__PURE__*/ _jsx(Text, {
                    c: "gray.7",
                    children: val
                }, val);
            })
        });
    } else {
        throw "Not implemented";
    }
};
var defaultProps = {
    readOnlyFormatter: renderValue
};
export var ValueWithLabel = factory(function(_props, ref) {
    var _ref = useProps("ViewFieldWrapper", defaultProps, _props), classNames = _ref.classNames, styles = _ref.styles, style = _ref.style, className = _ref.className, vars = _ref.vars, readOnlyFormatter = _ref.readOnlyFormatter, value = _ref.value, label = _ref.label, others = _object_without_properties(_ref, [
        "classNames",
        "styles",
        "style",
        "className",
        "vars",
        "readOnlyFormatter",
        "value",
        "label"
    ]);
    var getStyles = useStyles({
        name: "ViewFieldWrapper",
        classes: {},
        vars: vars,
        classNames: classNames,
        className: className,
        style: style,
        props: _props,
        styles: styles
    });
    return /*#__PURE__*/ _jsx(Input.Wrapper, _object_spread_props(_object_spread({
        ref: ref,
        label: label
    }, others, getStyles("root", {
        style: style,
        styles: styles,
        className: className,
        classNames: classNames
    })), {
        children: readOnlyFormatter(value)
    }));
});

//# sourceMappingURL=ValueWithLabel.js.map